// ================================================================
// Customers API — karte moshtari (Contact) + timeline-e Interaction
// Same apiRequest() pattern as core/email.js
// ================================================================
import { apiRequest } from './apiClient.js';

// list-e moshtari-ha (ba search-e ekhtiari). limit: server default 50, max 200 —
// safhe-haye adressbook (Kontakte-Tab) hame ra mikhahand, na 50 ta-ye akhar.
// onlyCustomers=true: faghat moshtari-haye VAGHEI — kasi ke barayash sanad-e
// ERSAL-SHODE darim (Offerte ya Rechnung). Ta'rif dar backend/customer-scope.ts.
export function listCustomers(search = '', limit = 0, onlyCustomers = false) {
  const p = new URLSearchParams();
  if (search) p.set('search', search);
  if (limit) p.set('limit', String(limit));
  if (onlyCustomers) p.set('customers', '1');
  const q = p.toString();
  return apiRequest('/api/customers' + (q ? '?' + q : ''));
}

// list-e moshtari-hayi ke حداقل yek sanad darand (Kunden 2 — safhe-ye asli)
// har moshtari: { id, name, email, phone, company, street, postalCode, city, docCount, status }
export function listCustomersWithDocuments(search = '') {
  const q = search ? '?search=' + encodeURIComponent(search) : '';
  return apiRequest('/api/customers/with-documents' + q);
}

// virayesh-e moshtari — PATCH (org-scoped). fields: {name, phone, email, company, street, postalCode, city}
export function updateCustomer(id, fields) {
  return apiRequest('/api/customers/' + encodeURIComponent(id), {
    method: 'PATCH',
    body: JSON.stringify(fields || {}),
  });
}

// jozئiyat-e yek moshtari + timeline
export function getCustomer(id) {
  return apiRequest('/api/customers/' + encodeURIComponent(id));
}

// kholase-ye AI az kol-e tarikhche-ye moshtari (lazy + cache dar backend)
// force=true: cache ra nadide begir va az no besaz
export function getCustomerSummary(id, force = false) {
  const q = force ? '?force=1' : '';
  return apiRequest('/api/customers/' + encodeURIComponent(id) + '/summary' + q);
}

// sakht-e moshtari-ye jadid — az tarigh-e hamun tool-e create_customer (mantegh-e moshtarak:
// check-e tekrari + org-scope + permission). vorudi: { name, phone_number, email, street, postal_code, city }
export async function createCustomer(args) {
  const body = await apiRequest('/api/voice/run-tool', {
    method: 'POST',
    body: JSON.stringify({ name: 'create_customer', args: args || {} }),
  });
  // body: { success, result: { result: 'created'|'already_exists', customer } }
  return body;
}

// ─── Ansprechpartner (ContactPerson) — shakhs-e rabet ───
// list-e rabet-haye yek moshtari
export function listContactPersons(contactId) {
  return apiRequest('/api/customers/' + encodeURIComponent(contactId) + '/persons');
}
// sakht-e rabet-e jadid. fields: { name, email, phone, role }
export function createContactPerson(contactId, fields) {
  return apiRequest('/api/customers/' + encodeURIComponent(contactId) + '/persons', {
    method: 'POST',
    body: JSON.stringify(fields || {}),
  });
}
// virayesh-e rabet. fields: { name, email, phone, role }
export function updateContactPerson(personId, fields) {
  return apiRequest('/api/customers/persons/' + encodeURIComponent(personId), {
    method: 'PATCH',
    body: JSON.stringify(fields || {}),
  });
}
// hazf-e rabet
export function deleteContactPerson(personId) {
  return apiRequest('/api/customers/persons/' + encodeURIComponent(personId), {
    method: 'DELETE',
  });
}

// ─── satl-e ashghal (soft-delete) ───
export function listTrashedCustomers() {
  return apiRequest('/api/customers/trash/list');
}
export function trashCustomer(id) {
  return apiRequest('/api/customers/' + encodeURIComponent(id) + '/trash', { method: 'POST' });
}
export function restoreCustomer(id) {
  return apiRequest('/api/customers/' + encodeURIComponent(id) + '/restore', { method: 'POST' });
}
export function deleteCustomerPermanent(id) {
  return apiRequest('/api/customers/' + encodeURIComponent(id) + '/permanent', { method: 'DELETE' });
}
